import React from "react";
import { useLocation } from "react-router-dom";
import { format, isValid, parseISO } from "date-fns";

// Component for displaying contact details in a read-only view
const ViewContactForm = () => {
  const location = useLocation();
  // Extract contact data from location state, fallback to empty object if not available
  const { data } = location.state || {};

  return (
    <div className="container-fluid p-0" style={{ overflow: "hidden" }}>
      <div
        className="row g-0"
        style={{ minHeight: "75vh", overflow: "hidden" }}
      >
        {/* Left Panel */}
        <div className="col-md-12 p-4 bg-white">
          {/* Grid layout for contact fields with 3 columns and custom spacing */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "3rem 5rem",
            }}
          >
            <div className="field">
              <span className="label">Name</span>
              <span className="value">{data?.name || "NA"}</span>
            </div>
            <div className="field">
              <span className="label">Job Title</span>
              <span className="value">{data?.job_title || "NA"}</span>
            </div>
            <div className="field">
              <span className="label">Phone Number</span>
              <span className="value">{data?.phone1 || "NA"}</span>
            </div>
            <div className="field">
              <span className="label">Email</span>
              <span className="value">{data?.email || "NA"}</span>
            </div>
            <div className="field">
              <span className="label">Bank Name</span>
              <span className="value">{data?.bank_name || "NA"}</span>
            </div>
            <div className="field">
              <span className="label">Branch Name</span>
              <span className="value">{data?.branch_name || "NA"}</span>
            </div>
            <div className="field">
              <span className="label">Contact Type</span>
              <span className="value">{data?.contact_type || "NA"}</span>
            </div>
            <div className="field">
              <span className="label">Skills</span>
              <span
                className="value"
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  display: "block",
                  width: "100%",
                }}
              >
                {data?.skills || "NA"}
              </span>
            </div>
            <div className="field">
              <span className="label">Agency Name</span>
              <span className="value">{data?.agency_name || "NA"}</span>
            </div>

            <div className="field">
              <span className="label">Updated On</span>
              <span className="value">
                {" "}
                {data?.updated_on && isValid(parseISO(data.updated_on))
                  ? format(parseISO(data.updated_on), "dd-MM-yyyy hh:mm a")
                  : "NA"}
              </span>
            </div>

            <div className="field">
              <span className="label">Status</span>
              <span className="value">{String(data?.status) || "NA"}</span>
            </div>
            <div className="field">
              <span className="label">Address</span>
              <span
                className="value"
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  display: "block",
                  width: "100%",
                }}
              >
                {data?.address || "NA"}
              </span>
            </div>
            <div className="field">
              <span className="label">Regions</span>
              <span
                className="value"
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  display: "block",
                  width: "200%",
                }}
              >
                {data?.region_name || "NA"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewContactForm;
